import { rem } from 'polished'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'

const _DetailCardLayout = styled.div`
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  padding: ${rem(20)};
  break-inside: avoid-page;
  display: grid;
  grid-template-columns: ${rem(64)} 1fr;
  grid-template-areas: 'image top' 'bottom bottom';
  gap: ${rem(12)} ${rem(16)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)} ${rem(40)};
    grid-template-columns: ${rem(104)} 1fr;
    grid-template-areas: 'image top' 'image bottom';
    gap: ${rem(8)} ${rem(20)};
  }
`

const ImageArea = styled.div`
  grid-area: image;
`

const TopArea = styled.div`
  grid-area: top;
`

const BottomArea = styled.div`
  grid-area: bottom;
`

const DetailCardLayout = _DetailCardLayout as typeof _DetailCardLayout & {
  Image: typeof ImageArea
  Top: typeof TopArea
  Bottom: typeof BottomArea
}

DetailCardLayout.Image = ImageArea
DetailCardLayout.Top = TopArea
DetailCardLayout.Bottom = BottomArea

export default DetailCardLayout
